import { type ErrorDetails } from '@makemydeal/dr-sales-checkin-types';
import { Snackbar } from '@makemydeal/dr-ui-bricks-components';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const GlobalErrorHandler: React.FC = () => {
    const errorDetails: ErrorDetails = useSelector((state: any) => {
        return state.salesCheckin.common.errorDetails || undefined;
    });
    const [isError, setIsError] = useState(!!errorDetails);

    useEffect(() => {
        setIsError(!!errorDetails);
    }, [errorDetails]);

    return <Snackbar open={isError} message={errorDetails?.message} type={errorDetails?.type} onClose={() => setIsError(false)} />;
};

export default GlobalErrorHandler;
